import {useEffect, useState} from 'react';


const Checkbox = (options) => {
    const [checked, setChecked] = useState(false)
    const [value, setValue] = useState(options.value || 'off')



    useEffect(() => {
        setChecked(value === 'on')
    }, [])


    const handleChange = (event) => {
        setChecked(event.target.checked)
        setValue(event.target.checked ? 'on' : 'off')

        if (typeof options.onChange == "function") {
            options.onChange(event)
        }
    }


    const Params = {
        value: value,
        type: 'checkbox',
        name: options.name,
        checked: checked,
        disabled: options.disabled,
        className: 'custom-control-input',
        id: `custom_switch_${options.name}`,
        onChange: handleChange
    }


    return (
        <div className="Checkbox">
            <div className={`custom-control custom-switch ${options.wrapper}`}>
                <input {...Params} />
                <label className="custom-control-label" aria-disabled={options.disabled} htmlFor={`custom_switch_${options.name}`}>
                    {options.label != null ? options.label : ''}
                </label>
            </div>
        </div>
    )
}

export default Checkbox;